var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-section-state home-section-state--empty"},[_c('span',{staticClass:"home-section-state__icon",attrs:{"aria-hidden":"true"}},[_vm._v("+")]),_c('p',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }